import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-32c881cc"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "modal fade",
  id: "modal_print_preview",
  ref: "printPreviewRef",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-1650px" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = {
  class: "modal-header",
  id: "kt_modal_print_preview_header"
}
const _hoisted_5 = { class: "fw-bolder m-0" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fs-6 text-gray-400" }, null, -1))
const _hoisted_7 = {
  "data-bs-dismiss": "modal",
  class: "btn btn-icon btn-sm btn-active-icon-primary"
}
const _hoisted_8 = { class: "svg-icon svg-icon-1" }
const _hoisted_9 = { class: "modal-body px-9" }
const _hoisted_10 = { class: "d-flex align-items-center justify-content-end mb-7" }
const _hoisted_11 = ["disabled"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle" }, null, -1))
const _hoisted_13 = { class: "svg-icon svg-icon-2" }
const _hoisted_14 = { class: "d-flex flex-column" }
const _hoisted_15 = { class: "fw-bolder" }
const _hoisted_16 = { class: "mb-3" }
const _hoisted_17 = ["id"]
const _hoisted_18 = { class: "d-flex flex-column gap-4 fw-bold mb-8" }
const _hoisted_19 = { class: "d-flex" }
const _hoisted_20 = { class: "w-160px text-gray-400 text-uppercase" }
const _hoisted_21 = { class: "flex-1 break-all" }
const _hoisted_22 = { class: "d-flex" }
const _hoisted_23 = { class: "w-160px text-gray-400 text-uppercase" }
const _hoisted_24 = { class: "flex-1 break-all" }
const _hoisted_25 = { class: "d-flex" }
const _hoisted_26 = { class: "w-160px text-gray-400 text-uppercase" }
const _hoisted_27 = { class: "flex-1 break-all" }
const _hoisted_28 = { class: "d-flex" }
const _hoisted_29 = { class: "w-160px text-gray-400 text-uppercase" }
const _hoisted_30 = { class: "flex-1 break-all" }
const _hoisted_31 = { class: "d-flex" }
const _hoisted_32 = { class: "w-160px text-gray-400 text-uppercase" }
const _hoisted_33 = { class: "flex-1 break-all" }
const _hoisted_34 = { class: "d-flex" }
const _hoisted_35 = { class: "w-160px text-gray-400 text-uppercase" }
const _hoisted_36 = { class: "flex-1 break-all" }
const _hoisted_37 = { class: "d-flex align-items-center justify-content-between mb-2" }
const _hoisted_38 = { class: "fw-bolder mb-0" }
const _hoisted_39 = { class: "flex-1 break-all ms-2 text-end" }
const _hoisted_40 = { class: "mb-3" }
const _hoisted_41 = ["id"]
const _hoisted_42 = { class: "d-flex flex-column gap-4 fw-bold" }
const _hoisted_43 = { class: "d-flex" }
const _hoisted_44 = { class: "w-160px text-gray-400 text-uppercase" }
const _hoisted_45 = { class: "flex-1 break-all" }
const _hoisted_46 = { class: "d-flex" }
const _hoisted_47 = { class: "w-160px text-gray-400 text-uppercase" }
const _hoisted_48 = { class: "flex-1 break-all" }
const _hoisted_49 = { class: "d-flex" }
const _hoisted_50 = { class: "w-160px text-gray-400 text-uppercase" }
const _hoisted_51 = { class: "flex-1 break-all" }
const _hoisted_52 = { class: "d-flex" }
const _hoisted_53 = { class: "w-160px text-gray-400 text-uppercase" }
const _hoisted_54 = { class: "flex-1 break-all" }
const _hoisted_55 = { class: "modal-footer align-items-center justify-content-end px-9" }
const _hoisted_56 = ["disabled"]
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle" }, null, -1))
const _hoisted_58 = { class: "svg-icon svg-icon-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg_icon = _resolveComponent("inline-svg-icon")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_form, {
          model: _ctx.formData,
          rules: _ctx.rules,
          ref: "formRef"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", null, [
                _createElementVNode("h2", _hoisted_5, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.t("inspection.printPreview")), 1)
                ]),
                _hoisted_6
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("span", _hoisted_8, [
                  _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr061.svg" })
                ])
              ])
            ]),
            _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_9, [
              _withDirectives(_createVNode(_component_el_form_item, { prop: "products" }, null, 512), [
                [_vShow, 0]
              ]),
              _withDirectives(_createVNode(_component_el_form_item, { prop: "templateURL" }, null, 512), [
                [_vShow, 0]
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("button", {
                  type: "button",
                  disabled: _ctx.loading,
                  class: "btn btn-lg btn-primary",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)))
                }, [
                  _withDirectives(_createElementVNode("span", null, [
                    _hoisted_12,
                    _createElementVNode("span", null, _toDisplayString(_ctx.t("common.pleaseWait")), 1)
                  ], 512), [
                    [_vShow, _ctx.loading]
                  ]),
                  _withDirectives(_createElementVNode("span", null, [
                    _createElementVNode("span", _hoisted_13, [
                      _createVNode(_component_inline_svg_icon, { src: "media/svg/custom/print.svg" })
                    ]),
                    _createElementVNode("span", null, _toDisplayString(_ctx.t("common.print")), 1)
                  ], 512), [
                    [_vShow, !_ctx.loading]
                  ])
                ], 8, _hoisted_11)
              ]),
              _createElementVNode("div", {
                class: _normalizeClass(["d-flex flex-wrap gap-9", {
                'justify-content-center': _ctx.formData.products.length < 3,
              }])
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formData.products, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "print-preview-template border border-dashed border-gray-300 bg-light rounded p-9",
                    key: index
                  }, [
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("h3", _hoisted_15, _toDisplayString(_ctx.t("inspection.article")), 1),
                      _createElementVNode("div", _hoisted_16, [
                        _createElementVNode("img", {
                          id: 'JsBarcodeArticle' + index
                        }, null, 8, _hoisted_17)
                      ]),
                      _createElementVNode("div", _hoisted_18, [
                        _createElementVNode("div", _hoisted_19, [
                          _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.t("order.articleNo")) + ": ", 1),
                          _createElementVNode("div", _hoisted_21, _toDisplayString(item.brand_article_no), 1)
                        ]),
                        _createElementVNode("div", _hoisted_22, [
                          _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.t("order.brand")) + ": ", 1),
                          _createElementVNode("div", _hoisted_24, _toDisplayString(item.brand), 1)
                        ]),
                        _createElementVNode("div", _hoisted_25, [
                          _createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.t("order.article")) + ": ", 1),
                          _createElementVNode("div", _hoisted_27, _toDisplayString(item.name), 1)
                        ]),
                        _createElementVNode("div", _hoisted_28, [
                          _createElementVNode("div", _hoisted_29, _toDisplayString(_ctx.t("order.color")) + ": ", 1),
                          _createElementVNode("div", _hoisted_30, _toDisplayString(item.color), 1)
                        ]),
                        _createElementVNode("div", _hoisted_31, [
                          _createElementVNode("div", _hoisted_32, _toDisplayString(_ctx.t("order.size")) + ": ", 1),
                          _createElementVNode("div", _hoisted_33, _toDisplayString(item.size), 1)
                        ]),
                        _createElementVNode("div", _hoisted_34, [
                          _createElementVNode("div", _hoisted_35, _toDisplayString(_ctx.t("order.ean")) + ": ", 1),
                          _createElementVNode("div", _hoisted_36, _toDisplayString(item.ean), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_37, [
                        _createElementVNode("h3", _hoisted_38, _toDisplayString(_ctx.t("inspection.shipment")), 1),
                        _createElementVNode("div", _hoisted_39, _toDisplayString(item.remark), 1)
                      ]),
                      _createElementVNode("div", _hoisted_40, [
                        _createElementVNode("img", {
                          id: 'JsBarcodeShipment' + index
                        }, null, 8, _hoisted_41)
                      ]),
                      _createElementVNode("div", _hoisted_42, [
                        _createElementVNode("div", _hoisted_43, [
                          _createElementVNode("div", _hoisted_44, _toDisplayString(_ctx.t("shipments.id")) + ": ", 1),
                          _createElementVNode("div", _hoisted_45, _toDisplayString(item.shipment_id), 1)
                        ]),
                        _createElementVNode("div", _hoisted_46, [
                          _createElementVNode("div", _hoisted_47, _toDisplayString(_ctx.t("common.proformaInvoice")) + ": ", 1),
                          _createElementVNode("div", _hoisted_48, _toDisplayString(item.proforma_invoice), 1)
                        ]),
                        _createElementVNode("div", _hoisted_49, [
                          _createElementVNode("div", _hoisted_50, _toDisplayString(_ctx.t("order.position")) + ": ", 1),
                          _createElementVNode("div", _hoisted_51, _toDisplayString(item.position), 1)
                        ]),
                        _createElementVNode("div", _hoisted_52, [
                          _createElementVNode("div", _hoisted_53, _toDisplayString(_ctx.t("inspection.ref")) + ": ", 1),
                          _createElementVNode("div", _hoisted_54, _toDisplayString(item.ref), 1)
                        ])
                      ])
                    ])
                  ]))
                }), 128))
              ], 2)
            ])), [
              [_directive_loading, _ctx.loading]
            ]),
            _createElementVNode("div", _hoisted_55, [
              _createElementVNode("button", {
                type: "button",
                disabled: _ctx.loading,
                class: "btn btn-lg btn-primary",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)))
              }, [
                _withDirectives(_createElementVNode("span", null, [
                  _hoisted_57,
                  _createElementVNode("span", null, _toDisplayString(_ctx.t("common.pleaseWait")), 1)
                ], 512), [
                  [_vShow, _ctx.loading]
                ]),
                _withDirectives(_createElementVNode("span", null, [
                  _createElementVNode("span", _hoisted_58, [
                    _createVNode(_component_inline_svg_icon, { src: "media/svg/custom/print.svg" })
                  ]),
                  _createElementVNode("span", null, _toDisplayString(_ctx.t("common.print")), 1)
                ], 512), [
                  [_vShow, !_ctx.loading]
                ])
              ], 8, _hoisted_56)
            ])
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ])
    ])
  ], 512))
}